import axios, { cacheTime } from "@axios";

import { getPartnerViewIdsForGroups, getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  monthDate: "",
  dates: [],
  sites: [],
  siteGroups: [],
  partnersList: [],
  partnersViews: [],
  partnerViewGroups: [],
  groupCA: true,
  year: "",
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getDates: (state) => state.dates,
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
    getPartnerViewGroups: (state) => state.partnerViewGroups,
    getPartnerViews: (state) => state.partnersViews,
    getPartnersList: (state) => state.partnersList,
    getMonthDate: (state) => state.monthDate,
    getGroupCA: (state) => state.groupCA,
    getYear: (state) => state.year,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setDates(state, payload) {
      state.dates = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },
    setPartnerViews(state, payload) {
      state.partnersViews = payload;
    },
    setPartnerViewGroups(state, payload) {
      state.partnerViewGroups = payload;
    },
    setPartnersList(state, payload) {
      state.partnersList = payload;
    },
    setMonthDate(state, payload) {
      state.monthDate = payload;
    },
    setGroupCA(state, payload) {
      state.groupCA = payload;
    },
    setYear(state, payload) {
      state.year = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const siteIds = await getSiteIdsForGroups(payload);
      commit("setSites", siteIds);

      return siteIds;
    },
    async updatePartnerViewGroups({ commit }, payload) {
      commit("setPartnerViewGroups", payload);
      if (!payload.length) {
        commit("setPartnerViews", []);
        return;
      }

      const partner_views_ids = await getPartnerViewIdsForGroups(payload);
      commit("setPartnerViews", partner_views_ids);
      return partner_views_ids;
    },
    async getPartnersList({ commit }) {
      const {
        data: { items },
      } = await axios.get("/partners/");
      commit("setPartnersList", items);

      return items;
    },
    async getDetailedRevenue({ commit }, payload) {
      const { data } = await axios.get(
        "/programmatic/detailed-revenue-monthly-report",
        {
          params: payload,
          cache: {
            maxAge: cacheTime,
          },
        }
      );

      return data;
    },
    updateMonthDate({ commit }, payload) {
      commit("setMonthDate", payload);
    },
    updatePartnerViews({ commit }, payload) {
      commit("setPartnerViews", payload);
    },
    updateGroupCA({ commit }, payload) {
      commit("setGroupCA", payload);
    },
    updateYear({ commit }, payload) {
      commit("setYear", payload);
    },
  },
};
